import { get } from './genericService';

export function getRequestTracker(id, success, failed) {
  return get('/api/v1/account/service-requests/' + (id || 'xxxx'), success, failed);
}
